import hExport from './src/h-export.vue'

hExport.install = function (Vue) {
  Vue.component(hExport.name, hExport);
};

export default hExport;